import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="element-remover"
export default class extends Controller {
  remove() {
    this.element.remove()
  }
}
